export default __webpack_public_path__ + "ed43b5b737324550a34c1f10b4e7eb16.png";